import { NotifyHelper } from "../../../helpers/toast";
import { eXepTkbChuanBiActionsObj } from "../../action-types/ke-hoach/IXepTkbChuanBiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const xepTkbChuanBiActions = {
  ...generateActions(eXepTkbChuanBiActionsObj, "XEP_TKB_CHUAN_BI"),
  ...generateActionForKey(eXepTkbChuanBiActionsObj, "XEP_TKB_CHUAN_BI", "TAO_LAI_THEO_MON_SUCCESS", () => {
    NotifyHelper.Success("Đã tạo lại lớp tín chỉ theo môn chọn");
  }),
  ...generateActionForKey(eXepTkbChuanBiActionsObj, "XEP_TKB_CHUAN_BI", "TAO_LAI_THEO_MON_ERROR", (error: string) => {
    NotifyHelper.Error(error);
  }),
  ...generateActionForKey(eXepTkbChuanBiActionsObj, "XEP_TKB_CHUAN_BI", "CAP_NHAT_SU_KIEN_SUCCESS", () => {
    NotifyHelper.Success("Đã cập nhật sự kiện");
  }),
  ...generateActionForKey(eXepTkbChuanBiActionsObj, "XEP_TKB_CHUAN_BI", "CAP_NHAT_SU_KIEN_ERROR", (error: string) => {
    NotifyHelper.Error(error);
  }),
};
